const BASE = 'https://et-pos.store/connector/api/accounting';

function getToken() {
  return localStorage.getItem('etpos_token') || '';
}

function headers() {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${getToken()}`,
  };
}

async function request(method, path, body) {
  const opts = { method, headers: headers() };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || `Request failed: ${res.status}`);
  return data;
}

export const accountingApi = {
  getAccountTypes:     ()           => request('GET',    '/account-types'),
  getAccounts:         ()           => request('GET',    '/accounts'),
  getAccount:          (id)         => request('GET',    `/accounts/${id}`),
  getAccountLedger:    (id)         => request('GET',    `/accounts/${id}/ledger`),

  getJournalEntries:   ()           => request('GET',    '/journal-entries'),
  getJournalEntry:     (id)         => request('GET',    `/journal-entries/${id}`),
  createJournalEntry:  (body)       => request('POST',   '/journal-entries', body),
  deleteJournalEntry:  (id)         => request('DELETE', `/journal-entries/${id}`),

  getTransactions:     ()           => request('GET',    '/transactions'),

  getTransfers:        ()           => request('GET',    '/transfers'),
  createTransfer:      (body)       => request('POST',   '/transfers', body),
  updateTransfer:      (id, body)   => request('PUT',    `/transfers/${id}`, body),
  deleteTransfer:      (id)         => request('DELETE', `/transfers/${id}`),

  getBudget:           (year)       => request('GET',    `/budget?financial_year=${year}`),
  saveBudget:          (body)       => request('POST',   '/budget', body),

  getTrialBalance:     ()           => request('GET',    '/reports/trial-balance'),
  getBalanceSheet:     ()           => request('GET',    '/reports/balance-sheet'),
  getArAgeing:         ()           => request('GET',    '/reports/ar-ageing'),
  getApAgeing:         ()           => request('GET',    '/reports/ap-ageing'),
};
